import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Icon } from '@src/elements/icon/icon'
import { CheckupStep } from '@src/data/checkup'
import { Divider } from '@src/elements/divider/divider'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'

import './progress-steps.sass'

@Component
export default class ProgressSteps extends Vue {

  @Prop({ required: true })
  private steps: CheckupStep[]

  // if the the first steps is ongoing, than the value is 1 (values: 1, 2,... n)
  // if no steps are ongoing, than the value is 0
  @Prop({ required: false, default: 0 })
  private step: number

  @Prop({ required: false })
  private changeStepCallback: (index: number) => void

  private currentStep: number = 0

  constructor () {
    super()
    this.currentStep = this.step
  }

  changeStep (index: number) {
    this.currentStep = index
    if (this.changeStepCallback) {
      this.changeStepCallback(index)
    }
  }

  render (h: CreateElement) {
    const steps: any[] = []
    const deviceSteps: any[] = []
    this.steps.forEach((step: CheckupStep, index: number) => {
      let desktopStep = (
        <div class={`step ${this.currentStep === index + 1 ? 'current' : ''} ${step.completed ? 'completed' : ''}`}>
          <div class='step-circle' onClick={() => {
            this.changeStep(index + 1)
          }}>
            {step.completed ? <Icon name='util/checkmark' color='white'/> : <Subtitle2>{index + 1}</Subtitle2>}
          </div>
          <Subtitle1>{this.$t(`PAGE.MEMBERS.ONBOARDING.STEPS.${step.type.toUpperCase()}`)}</Subtitle1>
        </div>
        )
      let deviceStep = (
        <div class={`step ${this.currentStep === index + 1 ? 'current' : ''} ${step.completed ? 'completed' : 'uncompleted'}`}>
          <div class='step-circle' onClick={() => {
            this.changeStep(index + 1)
          }}>
            {step.completed ? <Icon name='util/checkmark' color='white'/> : <Icon name='util/checkmark' color='white'/>}
          </div>
          <Subtitle1>{this.$t(`PAGE.MEMBERS.ONBOARDING.STEPS.${step.type.toUpperCase()}`)}</Subtitle1>
        </div>
        )
      steps.push(desktopStep)
      deviceSteps.push(deviceStep)
    })

    return <div class='steps-wrapper'>
      <Divider />
      <div class='steps desktop-steps'>
        {steps}
      </div>
      <div class='steps device-steps'>
        {deviceSteps}
      </div>
    </div>
  }

  beforeMount () {
    this.$watch('step', (newValue) => {
      this.currentStep = newValue
    })
  }
}
